stimulusApp.register(
  "offers-search-frame",
  class extends Stimulus.Controller {
    static targets = ["placeholder"]
    static values = {
      url: String,
    }

    #fetched = false

    // An eager frame starts its first fetch before Stimulus connects, so that
    // fetch never reaches markPageview — read it off the frame's attributes.
    connect() {
      this.#fetched =
        this.element.hasAttribute("src") &&
        (this.element.hasAttribute("busy") ||
          this.element.hasAttribute("complete"))
    }

    // Keep in sync with the `params["pageview"]` check in
    // front/app/views/front/offers/_search_results_content.html.slim: fetches
    // after the first one are filter/sort changes whose $pageview the morphed
    // page can no longer report itself.
    markPageview(event) {
      if (event.target !== this.element) return

      if (this.#fetched) event.detail.url.searchParams.set("pageview", "true")
      this.#fetched = true
    }

    urlValueChanged() {
      if (!this.urlValue) return

      if (!this.placeholderCopy && this.hasPlaceholderTarget) {
        this.placeholderCopy = this.placeholderTarget.cloneNode(true)
      }

      if (this.placeholderCopy) {
        this.element.innerHTML = ""
        this.element.appendChild(this.placeholderCopy.cloneNode(true))
      }
      this.element.setAttribute("src", this.urlValue)
    }
  },
)
